<nx-default-box-v2>

  <!-- label -->
  <ng-template nxTemplate="label">
    <div class="text-[1rem] font-medium leading-3r mt-[2px]">
      {{label()}}
      <p-progressSpinner
        ariaLabel="loading"
        *ngIf="isLoading()"
        styleClass="ml-[6px] w-[16px] h-[16px] black-spinner"
        strokeWidth="8"/>
    </div>
  </ng-template>

  <!-- content -->
  <ng-container [ngTemplateOutlet]="editMode() ? editTemplate : displayTemplate"></ng-container>

  <!-- actions -->
  <ng-template nxTemplate="mainEnd">
    <ng-container [ngTemplateOutlet]="editMode() ? editActionsTemplate : displayActionsTemplate"></ng-container>
  </ng-template>

</nx-default-box-v2>

<!-- content view mode -->
<ng-template #displayTemplate>
  <ng-container *ngIf="linkedEntityConnections().length > 0; else emptyTemplate">
    <div *ngFor="let connection of linkedEntityConnections()" class="flex items-center mb-0.5">
      <a [routerLink]="[buildEntityDetailsUrl(connection)]" class="jump">
        <span class="hover:underline cursor-pointer">{{connection.linkedEntity?.text}}</span>
      </a>
    </div>
  </ng-container>
  <ng-template #emptyTemplate>-</ng-template>
</ng-template>

<!-- content edit mode -->
<ng-template #editTemplate>
  <div class="mt-1" [formGroup]="form">
    <nx-edit-multiselect-input
      [showLabel]="false"
      [panelWidhtFull]="true"
      formControlName="selected"
      [filter]="true"
      [options]="options()"
      [placeholder]="placeholder()"
      [label]="label()">
    </nx-edit-multiselect-input>
  </div>
</ng-template>

<ng-template #displayActionsTemplate>
  <nx-default-button
    [style]="'dark'"
    (click)="edit()"
    [icon]="'icon-edit'"
    [tooltip]="'Bearbeiten'">
  </nx-default-button>
</ng-template>

<ng-template #editActionsTemplate>
  <nx-default-button
    [style]="'dark'"
    (click)="save()"
    class="mr-1"
    [disabled]="isLoading() || form?.pristine"
    [icon]="'icon-check'"
    [tooltip]="'Speichern'">
  </nx-default-button>
  <nx-default-button
    [style]="'dark'"
    (click)="cancel()"
    [disabled]="isLoading()"
    [icon]="'icon-cancel'"
    [tooltip]="'Abbrechen'">
  </nx-default-button>
</ng-template>
